import { render, staticRenderFns } from "./ZoneManage.vue?vue&type=template&id=5cf6090b&scoped=true&"
import script from "./ZoneManage.vue?vue&type=script&lang=js&"
export * from "./ZoneManage.vue?vue&type=script&lang=js&"
import style0 from "./ZoneManage.vue?vue&type=style&index=0&id=5cf6090b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6090b",
  null
  
)

export default component.exports